/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function useInterval(callback: () => void, delay: number): () => void {
  const id = setInterval(callback, delay);
  const cancel = (): void => clearInterval(id);

  /*                                                                                                                                        */
  $effect(() => cancel);

  /*                                                                */
  return cancel;
}
